module.exports = __webpack_public_path__ + "static/media/ndlo-logo.593f8707.png";